import React from 'react';
import withLazyLoad from 'bv-lazy-load';
import { hasSportsbook } from 'global-config';
import { useFeature } from 'bv-hooks';

import NavigationButtons from './navigation_buttons';
import PanelStylesApplicator from './panel_styles_applicator';
import CloseLayer from './close_layer';

const FloatingNavigation = () => {
  const [betslipRedux, betslipReduxResolved] = useFeature('betslip_redux');
  const SportsbookBetslip = hasSportsbook && betslipRedux ? withLazyLoad()('sportsbookBetslip') : () => null;
  if (!betslipReduxResolved) return null;

  return (
    <div className="floating-nav">
      <PanelStylesApplicator />
      <NavigationButtons />
      <CloseLayer />
      <SportsbookBetslip betslipType="mini-betslip" />
    </div>
  );
};

export default FloatingNavigation;
